import {
  Divider, IconButton, Input, List, ListItem, ListItemSecondaryAction, ListItemText, Select
} from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { useTranslation } from 'react-i18next';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { base64Reader, saveFotograf } from 'src/utils/storage/StrPhoto';
// import { getCategories } from 'src/utils/storage/commentCategories';
const Compress = require('compress.js');
const compress = new Compress();
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    borderTop: '1px solid rgba(0,0,0,0.1)',
    width: '100%',
    borderTop: '1px solid rgba(0,0,0,0.1);'
  },
  rootDetay: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    flexGrow: 1,
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0.5, 2)
  },
  input: {
    width: '100%'
  },
  divider: {
    width: 1,
    height: 24
  },
  fileInput: {
    display: 'none'
  }
}));

function ConversationForm({ getData, className, messages, WorkOrderId, ...rest }) {
  const classes = useStyles();
  const [value, setValue] = useState('');
  const [attachements, setAttachements] = useState({
    name: "",
    file: {},
    MIMEType: "",
    FileData: ""
  });
  const history = useHistory();
  const { t } = useTranslation('overview');
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: '0', ErrorDescription: 'İşleminiz başarı ile gerçekleştirildi.' });
  const [uyari, setUyari] = React.useState(false);
  const [KararData, setKararData] = React.useState([]);
  const [uyariTip, setUyariTip] = React.useState();
  const [valueKarar, setvalueKarar] = React.useState(0);
  const SessionUser = getUser();
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  useEffect(() => {
    const fetchCategories = async () => {
      // let cat = await getCategories();
      // setKararData(cat);
    };
    fetchCategories();
  }, []);

  const handleChange = (event) => {
    event.persist();
    setValue(event.target.value);
  };
  const handleChangeImage = async (event) => {
    var files = event.target.files[0];
    let base64Result = '';
    if (!window.navigator.onLine) {
      // offline
      let reader = new FileReader();
      reader.onload = function (base64) {
        saveFotograf(
          // ReceiptNo,
          base64.target.result,
          // DosyaTipi,
          files.name,
          files.type
        );
      };
      reader.readAsDataURL(files);
    } else {
      const meta = files?.type;
      if (meta.indexOf('image') !== -1) {
        const resizedImage = await compress.compress([files], {
          size: 0.3, // the max size in MB, defaults to 2MB
          quality: 1, // the quality of the image, max is 1,
          maxWidth: 1920, // the max width of the output image, defaults to 1920px
          maxHeight: 1920, // the max height of the output image, defaults to 1920px
          resize: true // defaults to true, set false if you do not want to resize the image width and height
        });
        const img = resizedImage[0];
        base64Result = img.data;
      } else {
        base64Result = await base64Reader(files);
      }
    }
    event.persist();
    setAttachements({
      name: files?.name,
      MIMEType: files?.type,
      file: files,
      FileData: base64Result
    });
  };
  console.log(attachements)


  const YorumGonder = (event) => {
    if (value === '') {
      setresponseMessage({ ErrorCode: 10, ErrorDescription: 'Lütfen yorum giriniz!...' });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    const data = [{
      AppNr: WorkOrderId,
      ServiceShopId: messages[0].BIRIM_KODU,
      CommentRequested: SessionUser.OrganizationUserId,
      UserId: SessionUser.OrganizationUserId,
      Comment: value,
      FileName: attachements?.name,
      MIMEType: attachements?.MIMEType,
      FileData: attachements?.FileData,
      Operation: 1,
      CommentId: messages[0].BASVURU_NO,
      Decision: valueKarar,
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisComment', data, config).then((response) => {
      const ResponseData = response.data;
      setresponseMessage(ResponseData);
      setValue("")
      getData()
      setAttachements({
        name: "",
        file: {},
        MIMEType: "",
        FileData: ""
      })
      // if (ResponseData.ErrorCode === '0') {
      //   history.push('/chat');
      // } else {
      //   setUyariTip('error');
      // }
      // setUyari(true);
    }).catch((error) => {

    });
  };
  const handleChangeKarar = (e) => {
    setvalueKarar(e.target.value);
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={classes.rootDetay}
      >
        <ListItem style={{ paddingTop: 0, paddingBottom: 0 }} >
          <ListItemText>
            {uyari
              && <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />}
            <Input
              disableUnderline
              multiline
              value={value}
              onChange={handleChange}
              placeholder={t('lblWriteAMessage')}
              fullWidth
            />
          </ListItemText>
          <div>
            {attachements?.name && attachements?.name}
            <IconButton
              color="primary"
              edge="end"
              size="small"
            >
              <label htmlFor="contained-button-file">
                <input
                  onChange={(e) => handleChangeImage(e)}
                  id="contained-button-file" style={{ display: "none" }} type="file" />
                <AttachFileIcon />
              </label>
            </IconButton>
          </div>
          <ListItemSecondaryAction className={classes.nested}>
            <IconButton
              color="primary"
              edge="end"
              onClick={YorumGonder}
              size="small"
            >
              <SendIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </List>


      <Divider className={classes.divider} />

    </div>
  );
}

ConversationForm.propTypes = {
  className: PropTypes.string
};

export default ConversationForm;
